import { render, staticRenderFns } from "./HojaDeAdmision.vue?vue&type=template&id=55823f93&scoped=true&"
import script from "./HojaDeAdmision.vue?vue&type=script&lang=js&"
export * from "./HojaDeAdmision.vue?vue&type=script&lang=js&"
import style0 from "./HojaDeAdmision.vue?vue&type=style&index=0&id=55823f93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55823f93",
  null
  
)

export default component.exports